module.exports = __webpack_public_path__ + "hubspot-logo-49215f2aea175303152a618999c2d4b1.png";